/**
 * Mobile Menu Dropdown Toggle
 * Handles the toggle of dropdown menus in mobile navigation
 */

export function initMobileMenuDropdown() {
	const navItems = document.querySelectorAll('.navbar-nav .nav-item.dropdown');
	
	if (!navItems.length) return;

	navItems.forEach(navItem => {
		const navLink = navItem.querySelector('.nav-link');
		
		if (!navLink) return;

		// Add click event to toggle dropdown
		navLink.addEventListener('click', (e) => {
			console.log('Mobile menu dropdown toggle');
			// Only prevent default on mobile
			if (window.innerWidth < 992) {
				e.preventDefault();
				
				// Close other dropdowns
				navItems.forEach(item => {
					if (item !== navItem) {
						item.classList.remove('show');
					}
				});
				
				// Toggle show class on the clicked nav-item
				navItem.classList.toggle('show');
			}
		});
	});

	// Close dropdowns when menu closes
	const navbarCollapse = document.getElementById('navbarSupportedContent');
	if (navbarCollapse) {
		navbarCollapse.addEventListener('hidden.bs.collapse', () => {
			// Remove show class from all dropdowns when menu closes
			navItems.forEach(navItem => {
				navItem.classList.remove('show');
			});
		});
	}
}
